import { createContext, useContext } from "react";
import { FeatureFlag } from "./activeFlags";

// isReady: false while a remote provider is still fetching its first values (every flag reads its
// registry default) or values for a newly signed-in person (flags still answer for the previous
// one). The local checker has nothing to wait for.
export const FeatureFlagContext = createContext({
  isFeatureActive: FeatureFlag.isFeatureActive,
  isReady: true,
});

export const useFeatureFlags = () =>
  useContext(FeatureFlagContext).isFeatureActive;

/** Whether flags have their real values yet; until then each reads its registry default. */
export const useFeatureFlagsReady = () =>
  useContext(FeatureFlagContext).isReady !== false;

export const useFeatureFlag = (flagName) => useFeatureFlags()(flagName);
